import { render, staticRenderFns } from "./AdvancedReview.vue?vue&type=template&id=4056061b&"
import script from "./AdvancedReview.vue?vue&type=script&lang=js&"
export * from "./AdvancedReview.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports